__turbopack_context__.v({
  "title": "menu-module-scss-module__j8Qc4W__title",
});
